import api from '../api'
import {fetchMeta} from './meta'
import {fetchService} from './service'
import {fetchSections} from './sections'
import {fetchFolders} from './library/folders'
import {refetchSets} from './library/sets'
import {refetchQuestions} from './library/questions'




export function dismissDomainMatchModal() {
	const requestData={
 		isbeModalSeen: true,
	}

	return (dispatch) => api.put('/meta',requestData)
		.then((response) => {
			dispatch({ type: 'UPDATE_META_SUCCESS', response })
			if(window.analytics){
				window.analytics.track('Dismissed Autodisplayed ISBE Modal')
			}

		})
		.catch((error) => {
			return error
		})
}

  
 

export function isbeOptIn(authCode) {
	const requestData={
 		authCode: authCode,
	}

	return (dispatch) => api.post('/isbe/opt-in',requestData)
		.then((response) => {
			dispatch(fetchMeta())
			dispatch(fetchService())
			dispatch(fetchSections())
			dispatch(fetchFolders())
			dispatch(refetchSets())
			dispatch(refetchQuestions())
			return response

		})
		// .catch((error) => {
		// 	return error
		// })
}




// WEBPACK FOOTER //
// ./src/actions/isbeDomainMatch.js